export default __webpack_public_path__ + "static/media/dt-over-85km.e2ef0c96.svg";